import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class VerbalizerEmailService {
  url: string = 'https://mail.boco-delphire.com/api/email/send/'
  subject: string = ''
  to: string = ''
  styles: any = {
    h2: 'font-size: 16px; font-weight: bold; margin: 0 0 8px 0;',
    h3: 'font-size: 14px; font-weight: bold; margin: 0 0 8px 0;',
    div: 'font-size: 14px; font-weight: normal; margin: 0 0 8px 0;'
  }

  send(response: any): void {
    this.setUp(response)
    const html: string = this.create(response)
    //!VERBTODO - COMMENT THIS BACK IN
    // this._send(response, html)
  }

  setUp(response: any): void {
    this.to = response.to
    this.subject = response.subject
  }

  createSubmission(data: any, response: any): string {
    // videoDuration = $filter('timeFormat') data.duration
    // notes = if data.notes then  data.notes else 'no notes'

    console.log('[ Email ] (createSubmission) data', data)
    const { target } = response
    if (target === 'user') {
      return `<div style="${this.styles.div}"><p>Thank you for your ${data.scenario.title}: ${data.scenario.name} submission. Your manager will review your submission and provide feedback. Please open the app and tap your history to see all your Verbalizer submissions and feedback.</p><p>Thank you</p></div>`
    } else {
      return `<div style="${this.styles.div}"><p>You have received a Verbalizer submission from ${data.user.email} for ${data.scenario.title}: ${data.scenario.name}. Please log into Verbalizer at your convenience to review.</p><p>Thank you</p></div>`
    }
  }

  createFeedback(data: any): string {
    console.log('[ Email ] (createFeedback) data', data)
    const { status } = data
    if (status === 'completed') {
      return `<div style="${this.styles.div}"><p>Your ${data.scenario.title}: ${data.scenario.name} submission has been approved. This scenario is now complete!</p><p>Thank you</p></div>`
    } else {
      return `<div style="${this.styles.div}"><p>Thank you for your ${data.scenario.title}: ${data.scenario.name} submission. Please review the feedback in the history tab of the Verbalizer app and re-record your submission within 48-hours for ${data.scenario.title}: ${data.scenario.name}.</p><p>Thank you</p></div>`
    }
  }

  create(response: any): string {
    console.log('[ Email ] (create) response', response)
    let str: string = ''
    const { data, type } = response
    switch (type) {
      case 'submission':
        str = this.createSubmission(data, response)
        break
      case 'feedback':
        str = this.createFeedback(data)
        break
    }
    return str
  }

  _send(response: any, str: string): Promise<any> {
    console.log('[ Email ] (_send) response', response)
    console.log('[ Email ] (_send) str', str)
    return new Promise((resolve, reject) => {
      const data: any = {
        to: this.to,
        from: 'Verbalizer <support@bocodigital.com>',
        replyTo: 'Verbalizer <support@bocodigital.com>',
        cc: null,
        bcc: null,
        subject: this.subject,
        message: str
      }

      console.log('[ Email ] (_send) Sending email', data)
      this.http.post(this.url, data).subscribe((resp) => {
        console.log('Email Response', resp)
        resolve(true)
      })
    })
  }

  constructor(private http: HttpClient) {}
}
